import { render, staticRenderFns } from "./FleetsScreen.vue?vue&type=template&id=bf8fcf76&scoped=true&"
import script from "./FleetsScreen.vue?vue&type=script&lang=js&"
export * from "./FleetsScreen.vue?vue&type=script&lang=js&"
import style0 from "./FleetsScreen.vue?vue&type=style&index=0&id=bf8fcf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8fcf76",
  null
  
)

export default component.exports